import { useCallback } from 'react'
import { useQueryParams } from './useQueryParams'

export type CompaniesFundsFilter = 'all' | 'withFunds'

export function useCompaniesFundsFilter(defaultTab?: string) {
  const queryParams = useQueryParams(defaultTab)

  const fundsFilter: CompaniesFundsFilter = queryParams.hasFunds === 'true' ? 'withFunds' : 'all'

  const setFundsFilter = useCallback(
    (filter: CompaniesFundsFilter) => {
      queryParams.updateMultiple({
        hasFunds: filter === 'withFunds' ? 'true' : undefined,
      })
    },
    [queryParams],
  )

  return { fundsFilter, setFundsFilter, queryParams }
}
